import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'odq-tooltip',
    templateUrl: './tooltip.component.html',
    styleUrls: ['./tooltip.component.scss'],
    standalone: false
})
export class TooltipComponent implements OnInit {

  @Input() tooltip: string;

  constructor() { }

  ngOnInit() {
  }

}
